import React, { useState } from 'react';

import { Button } from '..';
import { i18n } from '../../helpers/i18n';
import { Reason as ReasonType } from './constants';
import styles from './styles.css';

type Props = {
    initialChecked: boolean;
    reason: ReasonType;
    addReason: (reason: ReasonType) => void;
    deleteReason: (reason: ReasonType) => void;
};

export function Reason({ reason, initialChecked, addReason, deleteReason }: Props) {
    const [isChecked, setIsChecked] = useState(initialChecked);

    const onClick = () => {
        if (isChecked) {
            setIsChecked(false);
            deleteReason(reason);
        } else {
            setIsChecked(true);
            addReason(reason);
        }
    };

    return (
        <Button key={reason} size="sm" view={isChecked ? 'contrast' : 'neutral'} pin="round-round" onClick={onClick}>
            <span className={styles.reason}>{i18n('feedback', `reason_${reason}`)}</span>
        </Button>
    );
}
